// extracted by mini-css-extract-plugin
module.exports = {"container":"_2ph39p1x7pYakVh-bUx9C3","link":"zUnGbAreCtg-OUxNac1_u","active":"_21TjIajjhkAuGm7CCRlqg5","nameAvatar":"XGu67y2hBfGvTpDF4CzAo"};